<template>
  <div class="reservation-experiences-phone" v-if="upcomingReservation && upcomingReservation.lodging && upcomingReservation.lodging.experiences">
    <div class="experiences-section-phone">
      <!-- Title and Subtitle -->
      <div class="experiences-header-phone">
        <h2 class="merriweather-reg-24">Préparez votre escapade au {{ upcomingReservation.lodging.name }}</h2>
        <h3 class="raleway-reg-p15">À l’approche de votre escapade au {{ upcomingReservation.lodging.name }}, Hortense vous propose un carnet d’adresses sélectionné pour découvrir des expériences authentiques.</h3>
      </div>

      <!-- Experience Category Filters -->
      <div class="lodging-category-container" v-if="categories.length > 0">
        <h1
          v-for="category in categories"
          :key="category"
          class="lodging-category"
          :class="{ active: selectedCategory === category }"
          @click="selectedCategory = category"
        >
          <p class="raleway-reg-p16" :data-value="category">{{ formatCategoryName(category) }}</p>
        </h1>
      </div>

      <!-- Experiences Cards -->
      <template v-if="experiencesFiltered.length">
        <div class="card-lodging-container">
          <div v-for="(experience, index) in experiencesFiltered" :key="index">
            <Cardexplodging 
              :experience="experience" 
              :user="user" 
              :hideDescription="true" 
              @open-modal="openModal" 
              @connection="$emit('connection')"
            />
          </div>
        </div>
      </template>

      <!-- Empty State -->
      <template v-else>
        <p class="raleway-reg-p15 py-5 text-center">
          Hortense est à la recherche d'expériences à vous proposer près de cet hébergement
        </p>
      </template>

      <!-- Address Book Button -->
      <a 
        v-if="upcomingReservation.lodging.address_book" 
        :href="'/' + upcomingReservation.lodging.address_book.slug" 
        class="hortense-btn-primary mt-3"
        target="_blank"
      >
        DÉCOUVREZ NOTRE CARNET D'ADRESSES
      </a>
    </div>

    <!-- Experience Detail Modal -->
    <div v-if="showModal" class="modal-backdrop" @click.self="closeModal">
      <div class="modal-content">
        <div class="cross" @click.stop="closeModal">
          <img src="../../images/Croix fermer.svg" alt="fermer" />
        </div>
        <h4>{{ selectedExperience.name }}</h4>
        <h2>{{ selectedExperience.catch_phrase }}</h2>
        <p>{{ selectedExperience.description }}</p>
        <h2>Où ?</h2>
        <p class="address-clickable" @click="showExperienceOnMap">{{ selectedExperience.address }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import Cardexplodging from '../cards/Cardexplodging.vue';

export default {
  name: 'ReservationExperiencesPhone',
  components: {
    Cardexplodging,
  },
  props: {
    upcomingReservation: {
      type: Object,
      required: true,
    },
    user: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      selectedCategory: 'culturelles',
      categories: [
        'culturelles',
        'au naturel',
        'au bord de l\'eau',
        'sportives',
        'immersives',
        'culinaires',
        'diy',
        'oenologiques',
      ],
      showModal: false,
      selectedExperience: null,
    };
  },
  computed: {
    experiencesFiltered() {
      if (!this.upcomingReservation || !this.upcomingReservation.lodging || !this.upcomingReservation.lodging.experiences) {
        return [];
      }
      return this.upcomingReservation.lodging.experiences.filter(
        (exp) => exp.category_name === this.selectedCategory && exp.photo_key
      );
    },
  },
  methods: {
    formatCategoryName(category) {
      return category.charAt(0).toUpperCase() + category.slice(1);
    },
    openModal(experience) {
      this.selectedExperience = experience;
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
      this.selectedExperience = null;
    },
    showExperienceOnMap() {
      this.$emit('showExperienceOnMap', this.selectedExperience);
      this.closeModal();
    },
  },
};
</script>

<style scoped lang="scss">
.reservation-experiences-phone {
  width: 100%;
  margin: 30px 0;
  padding: 0 16px;

  @media screen and (max-width: 767px) {
    margin: 0;
  }
}

.experiences-section-phone {
  width: 100%;
}

.experiences-header-phone {
  margin-bottom: 24px;

  h2 {
    margin-bottom: 8px;
    color: #1a1a1a;
    font-size: 20px;
  }

  h3 {
    color: #555;
    margin: 0;
    font-size: 16px;
  }
}

.lodging-category-container {
  display: flex;
  gap: 1.5rem;
  overflow-y: scroll;
  margin-bottom: 24px;

  h1 {
    text-decoration: none;
    color: black;
    margin: 0;
    flex-shrink: 0;

    p {
      opacity: 0.4;
      text-transform: uppercase;
      width: max-content;
      margin: 0;
      font-size: 14px;
      font-weight: 400;
    }

    &:hover {
      p {
        opacity: 1;
      }
    }

    &.active {
      margin-bottom: 2rem;
      border-bottom: 3px solid #3b6152;
      width: fit-content;
      padding-bottom: 0.5rem;

      p {
        opacity: 1;
        font-family: 'Raleway', sans-serif;
        font-weight: 700;
        font-size: 16px;
        margin-bottom: 0.25rem;
      }
    }
  }
}

.card-lodging-container {
  display: flex;
  gap: 1.5rem;
  overflow-y: scroll;
  margin-bottom: 24px;
}

.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5) !important;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  opacity: 1 !important;
}

.modal-backdrop .modal-content {
  background: white;
  padding: 20px;
  border-radius: 5px;
  width: 95%;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  position: relative;
}

.cross {
  position: absolute;
  top: 8px;
  right: 8px;
  cursor: pointer;
  z-index: 10;

  img {
    width: 15px;
    height: 15px;
  }
}

.modal-backdrop .modal-content h2 {
  font-family: 'Raleway', sans-serif;
  font-weight: 700;
  font-size: 16px;
  line-height: 23.2px;
  letter-spacing: 0%;
  vertical-align: middle;
  text-transform: uppercase;
  margin-top: 16px;
  margin-bottom: 8px;
}

.modal-backdrop .modal-content h4 {
  font-family: 'Merriweather', serif;
  font-weight: 300;
  font-style: italic;
  font-size: 15px;
  line-height: 18px;
  letter-spacing: 0%;
  vertical-align: middle;
  margin: 0 0 8px 0;
}

.modal-backdrop .modal-content p {
  font-family: 'Raleway', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 22.5px;
  letter-spacing: 0%;
  vertical-align: middle;
  margin-bottom: 12px;
}

.address-clickable {
  cursor: pointer;
  text-decoration: underline;
  color: #3b6152;

  &:hover {
    opacity: 0.8;
  }
}

.mt-3 {
  margin-top: 16px;
}

.py-5 {
  padding-top: 40px;
  padding-bottom: 40px;
}

.text-center {
  text-align: center;
}
</style>
